import type { ComponentProps, ComponentType } from 'react'
import { MessageSquareIcon } from 'lucide-react'
import { cn } from '@joyful/utils'

export interface AgentConversationTabStatus {
  readonly description?: string
  readonly icon: ComponentType<ComponentProps<'svg'>>
  readonly isAnimated?: boolean
  readonly title: string
  readonly variant?: 'default' | 'muted'
}

export interface AgentConversationTabStatusIconProps extends ComponentProps<'svg'> {
  readonly status: AgentConversationTabStatus | null
}

export function AgentConversationTabStatusIcon({
  status,
  ...restProps
}: AgentConversationTabStatusIconProps) {
  if (status === null) {
    return <MessageSquareIcon {...restProps} />
  }

  const Icon = status.icon
  return (
    <Icon
      {...restProps}
      className={cn(
        status.isAnimated &&
          'text-tremor-content animate-[spin_3s_linear_infinite] motion-reduce:animate-none',
        restProps.className,
      )}
    />
  )
}
